module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"select":"Selecione","chooseYourBank":"Escolha seu banco"},"en-US":{"select":"Select","chooseYourBank":"Choose your bank"}}')
  delete Component.options._Ctor
}
